<template>
    <div class="warpper padding-sm">
        <div class="page-title line-height">支付管理</div>
        <div class="page-info">
            <div class="basic-info active">
                <el-form class="flex flex-direction justify-center" ref="ruleForm" :model="ruleForm"
                         :rules="rules" label-width="auto">
                    <el-form-item label="公众平台appid" prop="wx_appid">
                        <el-input v-model="ruleForm.wx_appid" placeholder="请输入公众平台appid"></el-input>
                    </el-form-item>
                    <el-form-item label="商户平台商户号(mch_id)" prop="wx_mch_id">
                        <el-input v-model="ruleForm.wx_mch_id" placeholder="请输入商户平台商户号"></el-input>
                    </el-form-item>
                    <el-form-item label="商户平台密钥(appsecret)" prop="wx_apikey">
                        <el-input v-model="ruleForm.wx_apikey" placeholder="请输入商户平台密钥"></el-input>
                    </el-form-item>
                    <el-button class="input-form-btn" @click="submitForm('ruleForm')" :loading="loading" v-if="user.isBranch">保存配置</el-button>
                </el-form>
            </div>
            <div class="tips"> 以上资料信息可登陆 <el-link class="link" target="_blank" href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2Findex.php%2Fextend%2Fproduct%2Flists%3Ftid%3D3">微信商户平台</el-link>
                申请或查看 <br>如有疑问，请拨打服务电话:{{service_phone}}</div>
        </div>
    </div>
</template>

<script>
    import {service_phone} from "@/utils/const";
    import {getWxPayInfo,setWxPayInfo} from '@/api/branch'
    export default {
        name: "pay",
        data() {
            return {
                service_phone: service_phone,
                ruleForm: {
                    wx_appid: '',
                    wx_mch_id: '',
                    wx_apikey: '',
                },
                rules: {
                    wx_appid: [
                        {required: true, message: "请输入公众平台appid", trigger: "blur"}
                    ],
                    wx_mch_id: [
                        {required: true, message: '请输入商户平台商户号', trigger: 'blur'}
                    ],
                    wx_apikey: [
                        {required: true, message: '请输入商户平台密钥', trigger: 'blur'}
                    ]

                },
                loading: false
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.$emit('setIndex', [4, 2], '支付设置')
            this.init()
        },
        components: {},
        methods: {
            async init() {
                let _data = await getWxPayInfo()
                if (_data.status === 200) {
                    this.ruleForm = {
                        wx_appid: _data.data.wx_appid,
                        wx_mch_id: _data.data.wx_mch_id,
                        wx_apikey: _data.data.wx_apikey,
                    }
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.setWxPayInfo()
                    }
                });
            },
            async setWxPayInfo() {
                this.loading = true
                let _data = await setWxPayInfo(this.ruleForm.wx_appid, this.ruleForm.wx_mch_id,this.ruleForm.wx_apikey)
                this.loading = false
                if (_data.status === 200) {
                    this.$message.success('提交成功')
                }
            }
        },
        filters: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    .warpper {
        padding: 20px 30px;
        background-color: #ffffff;
        border-radius: 10px;
        .page-info {
            display: flex;
            flex-direction: column;
            width: 719px;
            margin: 58px auto 0;
            .tips {
                font-size: 26px;
                font-weight: bold;
                text-align: center;
                margin: 30px;
              line-height: 36px;
              .link{
                display: inline;
                color: #ffb400;
                font-size: 26px;
                font-weight: bold;
                text-align: center;
                position: relative;
                top: -2px;
              }
            }
            .basic-info {
                display: flex;
                flex-direction: column;
                background-color: #ffffff;
                border-radius: 10px;
                padding: 40px 63px 20px 0px;
                &.active {
                    border: solid 1px #e4e4e4;
                    padding: 40px 63px 20px 30px;
                }
                .pay-money {
                    font-size: 16px;
                    color: #999999;
                    text-align: center;
                    margin: 20px 0;
                    span {
                        font-size: 24px;
                        color: #ed4444;
                    }
                }
                .el-select {
                    width: 100%;
                }
                .input-form-btn {
                    width: 200px;
                    height: 40px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#0a2240, #0a2240);
                    background-blend-mode: normal, normal;
                    border-radius: 20px;
                    font-size: 16px;
                    color: #ffffff;
                    margin: 30px auto 0;
                }
            }

        }
    }
</style>